import {
	CarrierText,
	OrderNumberText,
	TrackingNumberText,
	TruckNumberText,
	UnavailableDataPlaceholderText
} from "constants/text";
import { StyledOrderDetailsShipmentHeaderContainer } from "./OrderDetailsShipmentHeader.styles";
import { models } from "types/api/viewModels";

interface HeaderProps {
	orderDetail: models["OrderDetailViewModel"] | null | undefined;
	trackingNumber?: string | null;
	truckNumber?: string | null;
}

export const OrderDetailsShipmentHeader = ({ orderDetail, trackingNumber, truckNumber }: HeaderProps) => {
	return (
		<StyledOrderDetailsShipmentHeaderContainer>
			<div>
				<span>{OrderNumberText}</span>
				<span>{orderDetail?.orderNumber ?? UnavailableDataPlaceholderText}</span>
			</div>

			<div>
				<span>{CarrierText} </span>
				<span>{orderDetail?.shippingDetails?.carrierName ?? UnavailableDataPlaceholderText}</span>
			</div>

			{trackingNumber && (
				<div>
					<span>{TrackingNumberText}</span>
					<span>{trackingNumber}</span>
				</div>
			)}

			{truckNumber && (
				<div>
					<span>{TruckNumberText}</span>
					<span>{truckNumber}</span>
				</div>
			)}
		</StyledOrderDetailsShipmentHeaderContainer>
	);
};

export default OrderDetailsShipmentHeader;
